export const getIsVenueSettingsLoading = (state) =>
  state?.settings?.isLoading ?? false

export const getVenueSettings = (state) =>
  Object.values(state?.settings?.venueSettings?.settings?.byId ?? {})

export const getVenueDefaultSettings = (state) =>
  Object.values(
    state?.settings?.venueSettings?.defaultSettings?.byName ?? {}
  )

export const getSettingsForStands = (state) =>
  Object.values(state?.settings?.standsSettings?.settings?.byId ?? {})

export const getDefaultSettingsForStands = (state) =>
  Object.values(
    state?.settings?.standsSettings?.defaultSettings?.byName ?? {}
  )
